import React, { useEffect, useState } from 'react';

/**
 * TrioMobilDenetim: Trio Mobil tanışma sunumu + dışarıdan dijital denetim.
 * Route: /r/triomobil-denetim (sidebar YOK, tam ekran slayt).
 * Yeniden üretmek için: node src/pages/triomobil-denetim/build.js (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ~68KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function TrioMobilDenetim() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./triomobilDenetimHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Trio Mobil · Dışarıdan Bakınca"
      srcDoc={html}
      style={fill}
    />
  );
}
